'use strict'

module.exports = {
  //the default was 250, increased to 1000 to support long Santa urls with overrides
  maxUrlLength: 1000
}



// WEBPACK FOOTER //
// ../node_modules/dbsm-common/src/raven/baseParams.js